import * as R from 'ramda'
import compose from 'lodash/fp/compose'
import matches from 'lodash/fp/matches'
import reduce from 'lodash/fp/reduce'
import round from 'lodash/round'
import sortBy from 'lodash/fp/sortBy'

export function additional_costs_price(model) {
    return compose([

        // Auf 2 Stellen runden
        price => round(price, 2),

        // Zusammenzaehlen
        reduce((sum, price) => sum + price, 0),

        // Alle `nil`s ausfiltern
        R.reject(R.isNil),

        // Preis holen
        R.map(R.prop('amount'))

    ])(model.additionalCosts)
}

export function additional_costs_price_(models) {
    return R.compose(

        R.sum,

        R.map(R.prop('amount'))

    )(models)
}

export function contribution_margin_sum(model) {
    return shipping_margin_sum(model) + production_margin_sum(model)
}

export function is_any_published(models) {
    return R.compose(

        R.any(R.propEq('isPublished', true)),

    )(models)
}

export function is_best_price(model, models) {
    return R.compose(

        // Prufen ob kein niedrigerer Stueckpreis gefunden werden konnte
        R.isNil,

        // Nach einem niedrigeren Stueckpreis suchen
        R.find(unit_price => unit_price < per_unit_sum(model)),

        // Stueckpreise ermitteln
        R.map(per_unit_sum),

        // Preise mit anderer Auflage entfernen
        R.filter(matches({ printing: model.printing })),

        // `model` aus `models` entfernen
        R.reject(matches(model))

    )(models)
}

export function per_thousand_sum(model) {
    return R.compose(

        // ggf. Default-Wert setzen
        R.defaultTo(null),

        // Tausenderpreis berechenen
        totalSellingSum => totalSellingSum / model.printing * 1000,

        // Verkaufsumme berechenen
        total_selling_sum

    )(model)
}

export function production_selling_sum(model) {
    return model.production * (model.contributionMarginOfProduction / 100 + 1)
}

export function production_margin_sum(model) {
    return production_selling_sum(model) - model.production
}

export function selling_price(model, additionalCostModels) {
    return shipping_selling_sum(model) + production_selling_sum(model) + additional_costs_price_(additionalCostModels)
}

export function shipping_selling_sum(model) {
    return model.shipping * (model.contributionMarginOfShipping / 100 + 1)
}

export function shipping_margin_sum(model) {
    return shipping_selling_sum(model) - model.shipping
}

export function sort_by_printing_and_unit_price(models) {
    return R.compose(

        // Sortieren
        sortBy(['printing', 'per_unit_price']),

        // Stueckpreise hinzufuegen
        R.map(model => ({ ...model, per_unit_price: per_unit_sum(model), model }))

    )(models)
}

export function total_selling_sum(model) {
    return production_selling_sum(model) + shipping_selling_sum(model) + additional_costs_price(model)
}

export function per_unit_sum(model) {
    return total_selling_sum(model) / model.printing
}
